import PropertyDetail from './PropertyDetail.jsx'

export default PropertyDetail
